import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { TextField } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import RequiredButton from '../atoms/RequiredButton';
import ValidationText from '../atoms/ValidationText';

const styles = {
  titleModal: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '140%',
    marginBottom: 16
  },
  header: {
    fontSize: 18,
    fontWeight: 700
  },
  mainPaper: {
    minWidth: 400
  },
  dialogActionLeft: {
    justifyContent: 'flex-start'
  },
  noBorder: {
    border: 'none'
  },
  padding8: {
    padding: 8
  },
  bodyModal: {
    width: 460
  },
  error: {
    marginTop: 16
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  },
  titleText: {
    fontSize: 18,
    fontWeight: 700,
    marginLeft: 8
  },
  textField: {
    margin: 0,
    width: '100%'
  },
  noteMessage: {
    color: '#FF545C',
    fontSize: 16,
    fontWeight: 400,
    marginTop: 8
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openChange,
    cancelAction,
    openConfirmAction,
    titleMessageAdmin,
    seTitletMessageAdmin,
    titleMessageError,
    validTitleMessage,
    messageAdmin,
    setMessageAdmin,
    messageError,
    validMessageBody
  }) => {
    return (
      <>
        <Dialog
          open={openChange}
          onClose={cancelAction}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.bodyModal}>
            <Typography component="p" className={classes.titleModal}>
              お知らせ配信
            </Typography>
            <div className={classes.titleBox}>
              <RequiredButton />
              <span className={classes.titleText}>件名</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <TextField
                className={classes.textField}
                margin="normal"
                onChange={e => {
                  seTitletMessageAdmin(e.target.value);
                }}
                value={titleMessageAdmin}
                onBlur={validTitleMessage}
                inputProps={{ maxLength: 100 }}
              />
              <ValidationText message={titleMessageError} />
            </div>
            <div className={classes.titleBox}>
              <RequiredButton />
              <span className={classes.titleText}>内容</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <TextField
                multiline
                rows="4"
                className={classes.textField}
                margin="normal"
                onChange={e => {
                  setMessageAdmin(e.target.value);
                }}
                value={messageAdmin}
                onBlur={validMessageBody}
                inputProps={{ maxLength: 500 }}
              />
              <div className={classes.noteMessage}>※最大500文字</div>
              <ValidationText message={messageError} />
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogActionLeft}>
            <CancelButton color="primary" onClickAction={cancelAction} />
            <ChangeButton
              onClickAction={openConfirmAction}
              btnText="確認へ進む"
            />
          </DialogActions>
        </Dialog>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
